/*jshint esversion: 6 */
import Ajax from '../common/Ajax';
import * as Utils from '../common/Utils';
import DebugUtils from "../common/debug";
const _d = DebugUtils({debug: true}).log;

/*
   Purpose: Updates the video views field with a value obtained via an ajax call.
 */
export default (function(config){

    config.selector = (typeof  config.selector !== 'undefined') ?   config.selector : 'video-views';
    config.route = (typeof  config.route !== 'undefined') ?   config.route : '/widget/video/%id%/views';
    config.loading_value = (typeof  config.loading_value !== 'undefined') ?   config.loading_value : 'loading';
    config.error_value = (typeof  config.error_value !== 'undefined') ?   config.error_value : 0;

    let elements = document.getElementsByClassName(config.selector);

    /**
     * Check if the ID is valid
     *
     * @param id
     * @returns {boolean}
     */
    function isValid(id) {

        if (id === 'undefined') {
            console.log('ID is undefined');
            return false;
        }
    }

    /**
     * Create the route string
     *
     * @param id
     *
     * @returns {string}
     */
    function createRoute (id) {
        return Utils.generateRouteFromPattern({
                pattern : {
                    '%id%': id
                },
                route : config.route,
                env : config.env,
                locale: config.locale
            });
    }

    function updateValue(element, value)
    {
        element.getElementsByClassName('view-value')[0].innerHTML = value;
    }

    /**
     * @param route
     * @param element
     */
    function run(route, element) {

        let default_value = element.getAttribute('data-loading-value');

        let loading_value = (typeof  default_value !== 'undefined') ?  default_value : config.loading_value;

        updateValue(element, loading_value);

        /**
         * Ran on AJAX success
         *
         * @param response
         */
        let success = function(response){
            _d('Ajax success. response:');
            _d(response);
            let views = (typeof  response.views !== 'undefined') ?   response.views : config.error_value;

            updateValue(element, views);
        };


        /**
         * Ran on AJAX error
         *
         * @param response
         */
        let error = function(response){
            updateValue(element, config.error_value);
        };

        Ajax.getRequest(route, success, error);
    }

    for (let item of elements) {
        let id = item.getAttribute('data-id');

        if(false === isValid(id)) {
            console.log('Invalid id - cannot make the request');
            return false;
        }

        let route = createRoute(id);

        run(route, item);
    }

});


